define("media/components/media/label-media-item", ["exports", "@ember/component", "@ember/template-factory", "@ember/object", "@ember/service", "@ember/utils", "@glimmer/component", "@glimmer/tracking", "ember-concurrency", "shared/utils/uuid"], function (_exports, _component, _templateFactory, _object, _service, _utils, _component2, _tracking, _emberConcurrency, _uuid) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3;

  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@ember/utils",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-concurrency",0,"shared/utils/uuid"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <li class="o--dropBody__item cLB--dropBody__item eLB--dropBody__item" id={{this.htmlId}}>
    <div class="cLB--label {{if this.isActive 'is--active'}}" {{on "click" (fn @updateLabel @label)}}>
      <span class={{unless this.isActive "u--hide"}}>
        {{svg-jar "check" class="o--icon o--icon--success"}}
      </span>
      <span class="u--ellipsis">
        <span>
          {{@label.trimmedTagName}}
        </span>
      </span>
      {{#unless @label.isSystemLabel}}
        <span
          class="cLB--label__icon--edit cLB--label__icon {{if this.isEditing 'is--active'}}"
          {{on "click" this.editingToggle}}
        >
          {{svg-jar "ellipsis-h" class="o--icon o--icon--light"}}
        </span>
      {{/unless}}
    </div>
    {{#if this.isEditing}}
      <div class="cLB--label__expand" {{on "click" (perform this.deleteLabel)}}>
        {{svg-jar "trash" class="o--icon--sm u--m__r__xs"}}
        <span>
          {{t "shared_words.delete"}}
        </span>
      </div>
    {{/if}}
  </li>
  */
  {
    "id": "7u8pkpcM",
    "block": "[[[10,\"li\"],[14,0,\"o--dropBody__item cLB--dropBody__item eLB--dropBody__item\"],[15,1,[30,0,[\"htmlId\"]]],[12],[1,\"\\n  \"],[11,0],[16,0,[29,[\"cLB--label \",[52,[30,0,[\"isActive\"]],\"is--active\"]]]],[4,[38,1],[\"click\",[28,[37,2],[[30,1],[30,2]],null]],null],[12],[1,\"\\n    \"],[10,1],[15,0,[52,[51,[30,0,[\"isActive\"]]],\"u--hide\"]],[12],[1,\"\\n      \"],[1,[28,[35,4],[\"check\"],[[\"class\"],[\"o--icon o--icon--success\"]]]],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,1],[14,0,\"u--ellipsis\"],[12],[1,\"\\n      \"],[10,1],[12],[1,\"\\n        \"],[1,[30,2,[\"trimmedTagName\"]]],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\"],[41,[51,[30,2,[\"isSystemLabel\"]]],[[[1,\"      \"],[11,1],[16,0,[29,[\"cLB--label__icon--edit cLB--label__icon \",[52,[30,0,[\"isEditing\"]],\"is--active\"]]]],[4,[38,1],[\"click\",[30,0,[\"editingToggle\"]]],null],[12],[1,\"\\n        \"],[1,[28,[35,4],[\"ellipsis-h\"],[[\"class\"],[\"o--icon o--icon--light\"]]]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[1,\"  \"],[13],[1,\"\\n\"],[41,[30,0,[\"isEditing\"]],[[[1,\"    \"],[11,0],[24,0,\"cLB--label__expand\"],[4,[38,1],[\"click\",[28,[37,5],[[30,0,[\"deleteLabel\"]]],null]],null],[12],[1,\"\\n      \"],[1,[28,[35,4],[\"trash\"],[[\"class\"],[\"o--icon--sm u--m__r__xs\"]]]],[1,\"\\n      \"],[10,1],[12],[1,\"\\n        \"],[1,[28,[35,6],[\"shared_words.delete\"],null]],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[13]],[\"@updateLabel\",\"@label\"],false,[\"if\",\"on\",\"fn\",\"unless\",\"svg-jar\",\"perform\",\"t\"]]",
    "moduleName": "media/components/media/label-media-item.hbs",
    "isStrictMode": false
  });

  let LabelMediaItemComponent = (_class = class LabelMediaItemComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);

      _initializerDefineProperty(this, "dialogManager", _descriptor, this);

      _initializerDefineProperty(this, "intl", _descriptor2, this);

      _initializerDefineProperty(this, "isEditing", _descriptor3, this);

      _defineProperty(this, "htmlId", (0, _uuid.default)());

      this.isEditing = false;
    }

    get isActive() {
      return (0, _utils.isPresent)(this.args.mediaLabels) && !this.args.mediaLabels.any(label => label.isDestroyed) ? this.args.mediaLabels?.includes(this.args.label) : false;
    }

    editingToggle(event) {
      event.stopPropagation();
      this.isEditing = !this.isEditing;

      if (this.isEditing) {
        // This is all logic to make sure label and its 'editing' drop-down is fully visible --G
        const labelListElement = document.querySelector('.eLB--dropBody');
        if (labelListElement === null) return;
        const labelListOffsetTop = labelListElement.getBoundingClientRect().top;
        const element = document.getElementById(this.htmlId);
        if (element === null) return;
        const targetOffsetTop = element.getBoundingClientRect().top;
        const doubleTargetHeight = element.clientHeight * 2;
        const addLabelElement = document.querySelector('.eLB--dropFooter');
        if (addLabelElement === null) return;
        const addLabelOffsetTop = addLabelElement.getBoundingClientRect().top;
        const offsetBottomDifference = addLabelOffsetTop - targetOffsetTop;
        let differenceToMove;

        if (targetOffsetTop < labelListOffsetTop) {
          // If item on top, label not fully visible
          differenceToMove = labelListOffsetTop - targetOffsetTop;
          labelListElement.scrollBy({
            top: differenceToMove,
            left: 0,
            behavior: 'smooth'
          });
        } else if (offsetBottomDifference < doubleTargetHeight) {
          // If item on bottom, not fully visible
          differenceToMove = doubleTargetHeight - offsetBottomDifference;
          labelListElement.scrollBy({
            top: differenceToMove,
            left: 0,
            behavior: 'smooth'
          });
        }
      }
    }

    *deleteLabel() {
      const didConfirm = yield this.dialogManager.confirmation(this.intl.t('media_library.labels.manage.delete_header'), {
        description: this.intl.t('media_library.labels.manage.delete_message', {
          label_name: this.args.label.tagName
        }),
        confirmButton: this.intl.t('shared_words.delete')
      });

      if (!didConfirm) {
        return;
      }

      this.args.deleteLabel(this.args.label);
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "dialogManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "isEditing", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "editingToggle", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "editingToggle"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deleteLabel", [_emberConcurrency.task], Object.getOwnPropertyDescriptor(_class.prototype, "deleteLabel"), _class.prototype)), _class);
  _exports.default = LabelMediaItemComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, LabelMediaItemComponent);
});